import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/tools')({
  component: RouteComponent,
  head() {
    return {
      meta: [{ title: 'Tools' }],
    };
  },
});

function RouteComponent() {
  return (
    <div className="container mx-auto p-6">
      <h1 className="mb-6 text-2xl font-semibold">Tools</h1>
      <Outlet />
    </div>
  );
}
